/*
 *  Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import "url-search-params-polyfill";

export const getQueryParam = (url: string, paramName: string) => {
  return new URLSearchParams(url).get(paramName);
};
